import { createAction } from '../../libs/saga-utils';

const ns = 'venues';

export const VENUES_TYPES = {
  CREATE_REQUEST: `${ns}/CREATE_REQUEST`,
  CREATE_SUCCESS: `${ns}/CREATE_SUCCESS`,
  CREATE_FAILURE: `${ns}/CREATE_FAILURE`,

  LOAD_ALL_REQUEST: `${ns}/LOAD_ALL_REQUEST`,
  LOAD_ALL_SUCCESS: `${ns}/LOAD_ALL_SUCCESS`,
  LOAD_ALL_FAILURE: `${ns}/LOAD_ALL_FAILURE`,

  LOAD_REQUEST: `${ns}/LOAD_REQUEST`,
  LOAD_SUCCESS: `${ns}/LOAD_SUCCESS`,
  LOAD_FAILURE: `${ns}/LOAD_FAILURE`,

  LOAD_PERMISSIONS_REQUEST: `${ns}/LOAD_PERMISSIONS_REQUEST`,
  LOAD_PERMISSIONS_SUCCESS: `${ns}/LOAD_PERMISSIONS_SUCCESS`,
  LOAD_PERMISSIONS_FAILURE: `${ns}/LOAD_PERMISSIONS_FAILURE`,

  UPDATE_REQUEST: `${ns}/UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${ns}/UPDATE_SUCCESS`,
  UPDATE_FAILURE: `${ns}/UPDATE_FAILURE`,

  DELETE_REQUEST: `${ns}/DELETE_REQUEST`,
  DELETE_SUCCESS: `${ns}/DELETE_SUCCESS`,
  DELETE_FAILURE: `${ns}/DELETE_FAILURE`,

  UPDATE_FILTERS: `${ns}/UPDATE_FILTERS`
};

export const VENUES_ACTIONS = {
  createRequest: createAction(
    VENUES_TYPES.CREATE_REQUEST,
    (values, redirect) => ({ values, redirect })
  ),
  createSuccess: createAction(VENUES_TYPES.CREATE_SUCCESS, venue => ({
    venue
  })),
  createFailure: createAction(VENUES_TYPES.CREATE_FAILURE, error => ({
    error
  })),

  loadAllRequest: createAction(VENUES_TYPES.LOAD_ALL_REQUEST, params => ({
    params
  })),
  loadAllSuccess: createAction(VENUES_TYPES.LOAD_ALL_SUCCESS, venues => ({
    venues
  })),
  loadAllFailure: createAction(VENUES_TYPES.LOAD_ALL_FAILURE, error => ({
    error
  })),

  loadRequest: createAction(VENUES_TYPES.LOAD_REQUEST, id => ({ id })),
  loadSuccess: createAction(VENUES_TYPES.LOAD_SUCCESS, venue => ({ venue })),
  loadFailure: createAction(VENUES_TYPES.LOAD_FAILURE, error => ({ error })),

  loadPermissionsRequest: createAction(
    VENUES_TYPES.LOAD_PERMISSIONS_REQUEST,
    id => ({ id })
  ),
  loadPermissionsSuccess: createAction(
    VENUES_TYPES.LOAD_PERMISSIONS_SUCCESS,
    venue => ({ venue })
  ),
  loadPermissionsFailure: createAction(
    VENUES_TYPES.LOAD_PERMISSIONS_FAILURE,
    error => ({ error })
  ),

  updateRequest: createAction(VENUES_TYPES.UPDATE_REQUEST, (id, values) => ({
    id,
    values
  })),
  updateSuccess: createAction(VENUES_TYPES.UPDATE_SUCCESS, venue => ({
    venue
  })),
  updateFailure: createAction(VENUES_TYPES.UPDATE_FAILURE, error => ({
    error
  })),

  deleteRequest: createAction(VENUES_TYPES.DELETE_REQUEST, id => ({ id })),
  deleteSuccess: createAction(VENUES_TYPES.DELETE_SUCCESS, venue => ({
    venue
  })),
  deleteFailure: createAction(VENUES_TYPES.DELETE_FAILURE, error => ({
    error
  })),

  updateFilters: createAction(VENUES_TYPES.UPDATE_FILTERS, filters => ({
    filters
  }))
};
